import { jsx as _jsx } from "react/jsx-runtime";
import { TileFooter, TopTenChart, TileCard, } from '@cmd/ui-components';
import { useGetData } from '@cmd/ui-utilities';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { dateRangeSelector } from '../../../components/LandingPageHeader/LandingPageHeader';
import { organizationSelector } from '../../../state/orgIdState';
import leadsApi, { LeadsDataSource, LeadsResource } from '../../../utils/apis/leadsApiUtils';
import { getNvisionAnalyzeLeadsUrl } from '../../../utils/urlUtils';
import { topVehiclesDataFormatter } from './topVehiclesByLeadsUtils';
const tileConfigs = {
    [LeadsDataSource.ATKBB]: {
        sourceMessage: (intl) => intl.formatMessage({
            id: 'SOURCE_NVISION',
            defaultMessage: 'nVision',
        }),
    },
};
const TopVehiclesByLeads = ({ 'data-testid': dataTestId, limit = 10, // ToDo correct limit?
source, }) => {
    const intl = useIntl();
    const testId = `${dataTestId || 'ids'}-top-vehicles-by-leads`;
    const { sourceMessage } = tileConfigs[source] || { sourceMessage: () => '' };
    const dateRange = useSelector(dateRangeSelector);
    const orgId = useSelector(organizationSelector);
    const params = {
        orgId,
        ...dateRange,
        limit,
    };
    const endpoint = `${source}/${LeadsResource.TOP_VEHICLES}`;
    const { data, isLoading, error, } = useGetData(() => leadsApi[endpoint].get(params, {
        headers: {
            accept: 'application/vnd.coxauto.v2+json',
        },
    }), params, topVehiclesDataFormatter);
    const { chartData, lastUpdatedUTC } = data || {};
    return (_jsx(TileCard, { title: intl.formatMessage({
            id: 'TOP_VEHICLES_TILE_TITLE',
            defaultMessage: 'Top Vehicles by Leads',
        }), description: intl.formatMessage({
            id: 'TOP_VEHICLES_TILE_DESC',
            defaultMessage: 'Lead count for your highest interest inventory',
        }), className: "top-vehicles-by-leads", error: !!error, isLoading: isLoading, noData: (chartData || []).length === 0, "data-testid": testId ? `${testId}-widget-tile` : 'ids-widget-tile', footer: (_jsx(TileFooter, { sourceLabel: sourceMessage(intl), sourceLink: getNvisionAnalyzeLeadsUrl(dateRange), "data-testid": testId, lastUpdated: new Date(lastUpdatedUTC || '') })), children: _jsx(TopTenChart, { data: chartData || [], "data-testid": testId }) }));
};
export default TopVehiclesByLeads;
